import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0"
}
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-start" }
const _hoisted_4 = { class: "title m-0" }
const _hoisted_5 = { class: "text-black fw-medium mb-8" }
const _hoisted_6 = { class: "d-block text-dark-emphasis mb-0 small" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30" }, null, -1 /* HOISTED */)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "form-check form-group form-check mb-15 pointer-event-none" }
const _hoisted_10 = ["checked"]
const _hoisted_11 = {
  class: "form-check-label fw-medium position-relative top-1",
  for: "mandatory"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "mb-25" }, null, -1 /* HOISTED */)
const _hoisted_14 = {
  key: 1,
  class: "form-check form-group form-check mb-15 pointer-event-none"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input shadow-none me-8",
  type: "checkbox",
  id: "mandatory"
}, null, -1 /* HOISTED */)
const _hoisted_16 = {
  class: "form-check-label fw-medium position-relative top-1",
  for: "mandatory"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.version)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.version.title), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.version.revision_number), 1 /* TEXT */)
            ]),
            _createElementVNode("button", {
              class: "default-btn transition outlined fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.restore && _ctx.restore(...args)))
            }, _toDisplayString(_ctx.$t('cta.restore_consent_version')), 1 /* TEXT */)
          ]),
          _hoisted_7,
          _createCommentVNode(" BODY "),
          _createElementVNode("div", {
            class: "mb-15",
            innerHTML: _ctx.version.body
          }, null, 8 /* PROPS */, _hoisted_8),
          _createCommentVNode(" MANDATORY "),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("input", {
              class: "form-check-input shadow-none me-8",
              type: "checkbox",
              checked: _ctx.version.mandatory,
              id: "mandatory"
            }, null, 8 /* PROPS */, _hoisted_10),
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('form.mandatory.label')), 1 /* TEXT */)
          ]),
          (_ctx.version.mandatory && _ctx.version.mandatory_message)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.version.mandatory_message), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _hoisted_13,
          _createCommentVNode(" HAS CHECKBOX "),
          (_ctx.version.has_checkbox)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("label", _hoisted_16, [
                  _createCommentVNode(" {{ $t('form.has_checkbox.label') }} "),
                  _createTextVNode(" " + _toDisplayString(_ctx.version.checkbox_disclaimer), 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}